import { useQuery } from '@tanstack/react-query';

import { FlightEventClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightEventClient = new FlightEventClient(apiBaseUrl);

function useGetFlightEventDrafts() {
  return useQuery({
    queryKey: [queryKeys.FlightEvent.Drafts],
    queryFn: () => flightEventClient.getDrafts(),
  });
}

export default useGetFlightEventDrafts;
